import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutoCompleteData from 'components/list/Filters/types/autocomplete/AutoCompleteData';
import AutoCompleteField from 'components/list/Filters/types/autocomplete/AutoCompleteField';
import { Field } from 'redux-form';
import { fetchProductAccumulated } from 'store/actions/products/fetchProducts';
import { connect } from 'react-redux';

class RenderProductInputField extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.input.value.length && prevProps.input.value !== this.props.input.value) {
            this.props.fetchProductAccumulated(this.props.input.value);
        }
    }

    render() {
        const {
            fullWidth,
            input,
            label,
            minLength,
            onSelectOption,
            optionValue,
            reference,
            searchBy,
            searchParams,
        } = this.props;

        return (
            <AutoCompleteData
                input={ input }
                minLength={ minLength }
                reference={ reference }
                searchBy={ searchBy }
                searchParams={ searchParams }
            >
                <Field
                    component={ AutoCompleteField }
                    fullWidth={ fullWidth }
                    input={ input }
                    label={ label ? label : null }
                    name={ input.name }
                    optionText={ searchBy }
                    optionValue={ optionValue }
                    onSelectOption={ onSelectOption }
                />
            </AutoCompleteData>
        );
    }
}

RenderProductInputField.defaultProps = {
    fullWidth: false,
    minLength: 3,
    optionValue: 'id',
    reference: 'products',
    searchBy: 'title',
    searchParams: {
        size: '12',
        sort_by: 'title',
        sort_direction: 'asc',
    },
};

RenderProductInputField.propTypes = {
    fetchProductAccumulated: PropTypes.func,
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
    minLength: PropTypes.number,
    onSelectOption: PropTypes.func,
    optionValue: PropTypes.string,
    reference: PropTypes.string,
    searchBy: PropTypes.string,
    searchParams: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchProductAccumulated: (id) => {
            dispatch(fetchProductAccumulated({
                id: id,
            }));
        },
    };
};

export default connect(null, mapDispatchToProps)(RenderProductInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/AutoCompleteField/RenderProductInputField.js